import { AppSettingService } from './app-setting.service';
import { DatePipe } from '@angular/common';
import { FileExportService } from './file-export.service';
import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { PoandPBJreportDto } from '../model/poand-pbjreport-dto';

@Injectable({
  providedIn: 'root'
})
export class PdfFileService {

  constructor(public fileExportService: FileExportService, private datePipe: DatePipe, public appSettingService: AppSettingService) { }


  exportMsoLocationReport(fileName) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['MSO HQ Name', 'MSO Sold-to', 'MSO Name', 'MSO Street Address', 'MSO City', 'MSO State', 'MSO Zip', 'Servicing Distributor HQ Name', 'Servicing Distributor Sold-to', 'Servicing Distributor Name', 'Servicing Distributor Street Address', 'Servicing Distributor City', 'Servicing Distributor State', 'Servicing Distributor Zip'];

    let rows = [];
    this.fileExportService.selectedMsoLocationReportData.forEach(pdto => {
      if (pdto.rowCheck) {
        if(pdto.msoHqName == null || pdto.msoHqName == undefined || pdto.msoHqName == ""){
          pdto.msoHqName="";
        }
        if(pdto.msoSoldTo == null || pdto.msoSoldTo == undefined || pdto.msoSoldTo == ""){
          pdto.msoSoldTo="";
        }
        if(pdto.msoName == null || pdto.msoName == undefined || pdto.msoName == ""){
          pdto.msoName="";
        }
        if(pdto.msoStreetAddress == null || pdto.msoStreetAddress == undefined || pdto.msoStreetAddress == ""){
          pdto.msoStreetAddress="";
        }
        if(pdto.msoCity == null || pdto.msoCity == undefined || pdto.msoCity == ""){
          pdto.msoCity="";
        }
        if(pdto.msoState == null || pdto.msoState == undefined || pdto.msoState == ""){
          pdto.msoState="";
        }
        if(pdto.msoZip == null || pdto.msoZip == undefined || pdto.msoZip == ""){
          pdto.msoZip="";
        }
        if(pdto.servicingDistributorHqName == null || pdto.servicingDistributorHqName == undefined || pdto.servicingDistributorHqName == ""){
          pdto.servicingDistributorHqName="";
        }
        if(pdto.servicingDistributorSoldTo == null || pdto.servicingDistributorSoldTo == undefined || pdto.servicingDistributorSoldTo == ""){
          pdto.servicingDistributorSoldTo="";
        }
        if(pdto.servicingDistributorName == null || pdto.servicingDistributorName == undefined || pdto.servicingDistributorName == ""){
          pdto.servicingDistributorName="";
        }
        if(pdto.servicingDistributorStreetAddress == null || pdto.servicingDistributorStreetAddress == undefined || pdto.servicingDistributorStreetAddress == ""){
          pdto.servicingDistributorStreetAddress="";
        }
        if(pdto.servicingDistributorCity == null || pdto.servicingDistributorCity == undefined || pdto.servicingDistributorCity == ""){
          pdto.servicingDistributorCity="";
        }
        if(pdto.servicingDistributorState == null || pdto.servicingDistributorState == undefined || pdto.servicingDistributorState == ""){
          pdto.servicingDistributorState="";
        }
        if(pdto.servicingDistributorZip == null || pdto.servicingDistributorZip == undefined || pdto.servicingDistributorZip == ""){
          pdto.servicingDistributorZip="";
        }
          const temp = [pdto.msoHqName, pdto.msoSoldTo, pdto.msoName,  pdto.msoStreetAddress, pdto.msoCity, pdto.msoState,  pdto.msoZip, pdto.servicingDistributorHqName, pdto.servicingDistributorSoldTo,
          pdto.servicingDistributorName, pdto.servicingDistributorStreetAddress, pdto.servicingDistributorCity, pdto.servicingDistributorState, pdto.servicingDistributorZip];
        rows.push(temp);
      }
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 2,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        }
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }

  exportMonthlyLocationReport(fileName) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['Location Number', 'Customer Location Name', 'Customer Address1', 'Customer Address2', 'City', 'Creation Date in M2M'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    this.fileExportService.selectedMonthLocationReportData.forEach(pdto => {
      if (pdto.rowCheck) {
        let address2: any;
        let createDateTime: any;
        if (pdto.customerAddress2 === null) {
          address2 = '';
        } else {
          address2 = pdto.customerAddress2;
        }
        createDateTime = this.datePipe.transform(pdto.createdatetime, this.appSettingService.globelDateTimeFormat);
        const temp = [pdto.customerLocationid, pdto.customerLocationName, pdto.customerAddress1,
          address2, pdto.customerCity, createDateTime];
        rows.push(temp);
      }
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 7,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        }
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }

  exportPdfUnProcessReport(fileName) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['CreateDate', 'File Id', 'PONumber', 'FileName', 'Partner', 'DocumentType', 'Status', 'SubStatus', 'OnHoldReason'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    this.fileExportService.selectedUnprocessedPoReportData.forEach(pdto => {
      if (pdto.rowCheck) {
        let createDateTime: any;
        createDateTime = this.datePipe.transform(pdto.dateTimeOfCreation, this.appSettingService.globelDateTimeFormat);
        const temp = [createDateTime, pdto.fileId, pdto.purchaseOrderNumber,
          pdto.fileName, pdto.partner, pdto.documentType, pdto.status, pdto.subStatus, pdto.onHoldReason];
        rows.push(temp);
      }
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 6.6,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        }
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }

  exportPdfUnProcessReportAll(fileName, UnprocessedPoReportData) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['Create Date', 'File Id', 'PO Number', 'File Name', 'Partner', 'Document Type', 'Status', 'Sub Status', 'On Hold Reason'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    UnprocessedPoReportData.forEach(pdto => {
        let createDateTime: any;
        createDateTime = this.datePipe.transform(pdto.dateTimeOfCreation, this.appSettingService.globelDateTimeFormat);
        const temp = [createDateTime, pdto.fileId, pdto.purchaseOrderNumber,
          pdto.fileName, pdto.partner, pdto.documentType, pdto.status, pdto.subStatus, pdto.onHoldReason];
        rows.push(temp);
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 5,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        }
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }


  exportPbjDashboardAll(fileName, poandPBJreportDto: PoandPBJreportDto ) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['Date', 'PO', 'BoL ', 'Invoice', 'P2B', 'B2I','Sum of Shipped Qty 0'];
    const poCol = ['PO Date', 'PO', 'AxaltaCartKey', 'BoL', 'BoL Date','Invoice Number', 'Distributor Payer#','Partner Name',
    'MSO Entity Name', 'MSO Payer Account','Status','Order Quantity','Shipped Quantity'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    poandPBJreportDto.pPBJReportDtoList.forEach(pdto => {
        let createDateTime: any;
        createDateTime = this.datePipe.transform(pdto.dateOfCount, this.appSettingService.globelDateFormat);
        const temp = [createDateTime, pdto.repCountofPO, pdto.repCountBol, pdto.repCountInvoice,
           pdto.repCountBolNotReceived, pdto.repCountB2I, pdto.repCountShippedZero];
        rows.push(temp);
    });


    const poRows = [];
    poandPBJreportDto.poReportList.forEach(pdto => {
      let createDateTime: any;
      let bolDate: any;
      createDateTime = this.datePipe.transform(pdto.poDate, this.appSettingService.globelDateFormat);
      bolDate = this.datePipe.transform(pdto.bolDate, this.appSettingService.globelDateFormat);
      const temp = [ createDateTime, pdto.poNumber, pdto.axaltaCartKey, pdto.supplierDocReferenceNumber,
       bolDate, pdto.invoiceNumber , pdto.distributorPayerNumber, pdto.partnerName, pdto.msoEntityName,
        pdto.msoPayerAccount,  pdto.refCodeName, pdto.orderedQty, pdto.shippedQty];

      poRows.push(temp);
    });

    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 7,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        },
      },
      theme: 'grid'
    });
    doc.addPage();

    doc.autoTable(poCol, poRows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 7,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto',
        },
        0: {cellWidth: 45},
        1: {cellWidth: 60},
        2: {cellWidth: 60},
        3: {cellWidth: 60},
        4: {cellWidth: 45},
        5: {cellWidth: 60},
        6: {cellWidth: 40},
        7: {cellWidth: 40},
        8: {cellWidth: 30},
        9: {cellWidth: 30},
        10: {cellWidth: 30},
        11: {cellWidth: 10},
        12: {cellWidth: 10},
      },
      theme: 'grid'
    });
    doc.save(fileName + '.pdf');
  }



  exportPbjDashboard(fileName, poandPBJreportDto: PoandPBJreportDto ) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['Date', 'PO', 'BoL ', 'Invoice', 'P2B', 'B2I','Sum of Shipped Qty 0'];
    const poCol = ['PO Date', 'PO', 'AxaltaCartKey', 'BoL', 'BoL Date','Invoice Number', 'Distributor Payer#','Partner Name',
    'MSO Entity Name', 'MSO Payer Account','Status','Order Quantity','Shipped Quantity'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    this.fileExportService.selectedPbjReportData.forEach(pdto => {
      if (pdto.rowCheck) {
        let createDateTime: any;
        createDateTime = this.datePipe.transform(pdto.dateOfCount, this.appSettingService.globelDateFormat);
        const temp = [createDateTime, pdto.repCountofPO, pdto.repCountBol, pdto.repCountInvoice,
           pdto.repCountBolNotReceived, pdto.repCountB2I, pdto.repCountShippedZero];
        rows.push(temp);
      }
    });


    const poRows = [];
    poandPBJreportDto.poReportList.forEach(pdto => {
      let createDateTime: any;
      let bolDate: any;
      createDateTime = this.datePipe.transform(pdto.poDate, this.appSettingService.globelDateFormat);
      bolDate = this.datePipe.transform(pdto.bolDate, this.appSettingService.globelDateFormat);
      const temp = [ createDateTime, pdto.poNumber, pdto.axaltaCartKey, pdto.supplierDocReferenceNumber,
       bolDate, pdto.invoiceNumber , pdto.distributorPayerNumber,  pdto.partnerName, pdto.msoEntityName,
        pdto.msoPayerAccount, pdto.refCodeName, pdto.orderedQty, pdto.shippedQty];

      poRows.push(temp);
    });

    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 7,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        }
      },
      theme: 'grid'
    });
    doc.addPage();

    doc.autoTable(poCol, poRows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 4.5,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        }
      },
      theme: 'grid'
    });
    doc.save(fileName + '.pdf');
  }


  exportMonthlyExceptionReportCCPdfAll(fileName, exceptionReportDtoM2mList) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['Created Date ', 'Year', 'Month', 'Distributor Payer', 'Purchase Order Number','SupplierDocRefNumber',
     'Item Error Code', 'Item Error Description', ];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    exceptionReportDtoM2mList.forEach(pdto => {
      let fileId: any;
      let supplierDocRefNumber: any;
      let year: any;
      let month: any;
      let distributorName: any;
      let refCodeName: any;
      let refcodeid: any;
      let purchaseOrderNumber: any;
      let itemErrorCode: any;
      let itemErrorDescription: any;
      let datetimeOfCreation: any;

      if (pdto.datetimeOfCreation === null) {
        datetimeOfCreation = '';
      } else {
        datetimeOfCreation = this.datePipe.transform(pdto.datetimeOfCreation, this.appSettingService.globelDatePickerInUSAFormat);
      }
      if (pdto.year === null) {
        year = '';
      } else {
        year = pdto.year;
      }
      if (pdto.month === null) {
        month = '';
      } else {
        month = pdto.month;
      }
      if (pdto.distributorName === null) {
        distributorName = '';
      } else {
        distributorName = pdto.distributorName;
      }
      if (pdto.purchaseOrderNumber === null) {
        purchaseOrderNumber = '';
      } else {
        purchaseOrderNumber = pdto.purchaseOrderNumber;
      }
      if (pdto.itemErrorCode === null) {
        itemErrorCode = '';
      } else {
        itemErrorCode = pdto.itemErrorCode;
      }
      if (pdto.itemErrorDescription === null) {
        itemErrorDescription = '';
      } else {
        itemErrorDescription = pdto.itemErrorDescription;
        var fixedSize=51;
        var minLength=0;
        if(itemErrorDescription.length > fixedSize){
          var totalLines = itemErrorDescription.length/fixedSize;
          for(var i=0; i<totalLines;i++){
            this.copyOfItemErrorDescription =this.copyOfItemErrorDescription+ itemErrorDescription.substring(minLength,fixedSize)+"\r";
            minLength=fixedSize;
            fixedSize=2*fixedSize;

          }
          itemErrorDescription=this.copyOfItemErrorDescription;
          this.copyOfItemErrorDescription="";
        }
      }
      if (pdto.supplierDocRefNumber === null) {
        supplierDocRefNumber = '';
      } else {
        supplierDocRefNumber = pdto.supplierDocRefNumber;
      }
        const temp = [datetimeOfCreation,  year, month,distributorName,purchaseOrderNumber,supplierDocRefNumber,
          itemErrorCode, itemErrorDescription];
        rows.push(temp);
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 5,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        },
        1: {columnWidth: 100},
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }


  exportMonthlyExceptionReportM2mPdfAll(fileName, exceptionReportDtoM2mList) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['Created Date ', 'MSO', 'Year', 'Month', 'Distributor Payer', 'Purchase Order Number','SupplierDocRefNumber',
     'Item Error Code', 'Item Error Description', 'Cart Key'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    exceptionReportDtoM2mList.forEach(pdto => {
      let createdDate: any;
      let mso: any;
      let year: any;
      let month: any;
      let distributorPayer: any;
      let purchaseOrderNumber: any;
      let itemErrorCode: any;
      let itemErrorDescription: any;
      let supplierDocRefNumber: any;
      let axaltaCartKey: any;
      if (pdto.createdDate === null) {
        createdDate = '';
      } else {
        createdDate = this.datePipe.transform(pdto.createdDate, this.appSettingService.globelDatePickerInUSAFormat);
      }
      if (pdto.mso === null) {
        mso = '';
      } else {
        mso = pdto.mso;
      }
      if (pdto.year === null) {
        year = '';
      } else {
        year = pdto.year;
      }
      if (pdto.month === null) {
        month = '';
      } else {
        month = pdto.month;
      }
      if (pdto.distributorPayer === null) {
        distributorPayer = '';
      } else {
        distributorPayer = pdto.distributorPayer;
      }
      if (pdto.purchaseOrderNumber === null) {
        purchaseOrderNumber = '';
      } else {
        purchaseOrderNumber = pdto.purchaseOrderNumber;
      }
      if (pdto.itemErrorCode === null) {
        itemErrorCode = '';
      } else {
        itemErrorCode = pdto.itemErrorCode;
      }
      if (pdto.itemErrorDescription === null) {
        itemErrorDescription = '';
      } else {
        itemErrorDescription = pdto.itemErrorDescription;
        var fixedSize=51;
        var minLength=0;
        if(itemErrorDescription.length > fixedSize){
          var totalLines = itemErrorDescription.length/fixedSize;
          for(var i=0; i<totalLines;i++){
            this.copyOfItemErrorDescription =this.copyOfItemErrorDescription+ itemErrorDescription.substring(minLength,fixedSize)+"\r";
            minLength=fixedSize;
            fixedSize=2*fixedSize;

          }
          itemErrorDescription=this.copyOfItemErrorDescription;
          this.copyOfItemErrorDescription="";
        }
      }
      if (pdto.supplierDocRefNumber === null) {
        supplierDocRefNumber = '';
      } else {
        supplierDocRefNumber = pdto.supplierDocRefNumber;
      }
      if (pdto.axaltaCartKey === null) {
        axaltaCartKey = '';
      } else {
        axaltaCartKey = pdto.axaltaCartKey;
      }
        const temp = [createdDate, mso, year, month,distributorPayer,purchaseOrderNumber,supplierDocRefNumber,
          itemErrorCode, itemErrorDescription, axaltaCartKey];
        rows.push(temp);
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 5,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        },
        1: {columnWidth: 100},
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }

  exportMonthlyExceptionReportCCPdf(fileName) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['Created Date ', 'Year', 'Month', 'Distributor Payer', 'Purchase Order Number','SupplierDocRefNumber',
    'Item Error Code', 'Item Error Description'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    this.fileExportService.selectedMonthlyExceptionsReportCcData1.forEach(pdto => {
      if (pdto.rowCheck) {
        let fileId: any;
        let supplierDocRefNumber: any;
        let year: any;
        let month: any;
        let distributorName: any;
        let refCodeName: any;
        let refcodeid: any;
        let purchaseOrderNumber: any;
        let itemErrorCode: any;
        let itemErrorDescription: any;
        let datetimeOfCreation: any;

        if (pdto.datetimeOfCreation === null) {
          datetimeOfCreation = '';
        } else {
          datetimeOfCreation = this.datePipe.transform(pdto.datetimeOfCreation, this.appSettingService.globelDatePickerInUSAFormat);
        }
        if (pdto.year === null) {
          year = '';
        } else {
          year = pdto.year;
        }
        if (pdto.month === null) {
          month = '';
        } else {
          month = pdto.month;
        }
        if (pdto.distributorName === null) {
          distributorName = '';
        } else {
          distributorName = pdto.distributorName;
        }
        if (pdto.purchaseOrderNumber === null) {
          purchaseOrderNumber = '';
        } else {
          purchaseOrderNumber = pdto.purchaseOrderNumber;
        }
        if (pdto.itemErrorCode === null) {
          itemErrorCode = '';
        } else {
          itemErrorCode = pdto.itemErrorCode;
        }
        if (pdto.itemErrorDescription === null) {
          itemErrorDescription = '';
        } else {
          itemErrorDescription = pdto.itemErrorDescription;
          var fixedSize=51;
          var minLength=0;
          if(itemErrorDescription.length > fixedSize){
            var totalLines = itemErrorDescription.length/fixedSize;
            for(var i=0; i<totalLines;i++){
              this.copyOfItemErrorDescription =this.copyOfItemErrorDescription+ itemErrorDescription.substring(minLength,fixedSize)+"\r";
              minLength=fixedSize;
              fixedSize=2*fixedSize;

            }
            itemErrorDescription=this.copyOfItemErrorDescription;
            this.copyOfItemErrorDescription="";
          }
        }
        if (pdto.supplierDocRefNumber === null) {
          supplierDocRefNumber = '';
        } else {
          supplierDocRefNumber = pdto.supplierDocRefNumber;
        }


        const temp = [datetimeOfCreation,year, month,distributorName,purchaseOrderNumber,supplierDocRefNumber,
          itemErrorCode, itemErrorDescription];
        rows.push(temp);
      }
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 5,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        },
        1: {columnWidth: 100},
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }

  exportMonthlyExceptionReportM2mPdf(fileName) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['Created Date ', 'MSO', 'Year', 'Month', 'Distributor Payer', 'Purchase Order Number','SupplierDocRefNumber',
    'Item Error Code', 'Item Error Description', 'Cart Key'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    this.fileExportService.selectedMonthlyExceptionsReportM2MData1.forEach(pdto => {
      if (pdto.rowCheck) {
        let createdDate: any;
        let mso: any;
        let year: any;
        let month: any;
        let distributorPayer: any;
        let purchaseOrderNumber: any;
        let itemErrorCode: any;
        let itemErrorDescription: any;
        let supplierDocRefNumber: any;
        let axaltaCartKey: any;
        if (pdto.createdDate === null) {
          createdDate = '';
        } else {
          createdDate = this.datePipe.transform(pdto.createdDate, this.appSettingService.globelDatePickerInUSAFormat);
        }
        if (pdto.mso === null) {
          mso = '';
        } else {
          mso = pdto.mso;
        }
        if (pdto.year === null) {
          year = '';
        } else {
          year = pdto.year;
        }
        if (pdto.month === null) {
          month = '';
        } else {
          month = pdto.month;
        }
        if (pdto.distributorPayer === null) {
          distributorPayer = '';
        } else {
          distributorPayer = pdto.distributorPayer;
        }
        if (pdto.purchaseOrderNumber === null) {
          purchaseOrderNumber = '';
        } else {
          purchaseOrderNumber = pdto.purchaseOrderNumber;
        }
        if (pdto.itemErrorCode === null) {
          itemErrorCode = '';
        } else {
          itemErrorCode = pdto.itemErrorCode;
        }
        if (pdto.itemErrorDescription === null) {
          itemErrorDescription = '';
        } else {
          itemErrorDescription = pdto.itemErrorDescription;
          var fixedSize=51;
          var minLength=0;
          if(itemErrorDescription.length > fixedSize){
            var totalLines = itemErrorDescription.length/fixedSize;
            for(var i=0; i<totalLines;i++){
              this.copyOfItemErrorDescription =this.copyOfItemErrorDescription+ itemErrorDescription.substring(minLength,fixedSize)+"\r";
              minLength=fixedSize;
              fixedSize=2*fixedSize;

            }
            itemErrorDescription=this.copyOfItemErrorDescription;
            this.copyOfItemErrorDescription="";
          }
        }
        if (pdto.supplierDocRefNumber === null) {
          supplierDocRefNumber = '';
        } else {
          supplierDocRefNumber = pdto.supplierDocRefNumber;
        }
        if (pdto.axaltaCartKey === null) {
          axaltaCartKey = '';
        } else {
          axaltaCartKey = pdto.axaltaCartKey;
        }

        const temp = [createdDate, mso, year, month,distributorPayer,purchaseOrderNumber,supplierDocRefNumber,
          itemErrorCode, itemErrorDescription, axaltaCartKey];
        rows.push(temp);
      }
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 5,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        },
        1: {columnWidth: 100},
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }
   copyOfItemErrorDescription : string="";
  exportEdiEdparTable(fileName) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['Create Date', 'EDI TP ID', 'EDI Ship To', 'SAP Payer', 'SAP Ship To', 'Template','Direct Orders'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    this.fileExportService.selectedEdiEdparData.forEach(pdto => {
      if (pdto.rowCheck) {
        if(pdto.directOrdersAllowedFlg == null || pdto.directOrdersAllowedFlg == undefined){
          pdto.directOrdersAllowedFlg="";
        }
        let createDateTime: any;
        createDateTime = this.datePipe.transform(pdto.creationDate, this.appSettingService.globelDatePickerInUSAFormat);
        const temp = [createDateTime , pdto.ediTpId, pdto.ediTpShiptoCd, pdto.sapPayerNum,
           pdto.sapShiptoNum, pdto.indirectContactTemplateCd, pdto.directOrdersAllowedFlg.toUpperCase()];
        rows.push(temp);
      }
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 7,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        }
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }

  copyOfInvoice: string="";
  exportPurchaseOrderReportTable(fileName) {
    const doc = new jsPDF('l', 'pt', 'a4');
 const col = ['PO Date', 'PO#', 'AxaltaCartKey', 'BoL#', 'BoL Date','Invoice#', 'Distributor Payer#', 'Partner Name','MSO Entity Name', 'MSO Payer Account','Status','Order Quantity','Shipped Quantity'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    this.fileExportService.selectedPurchaseOrderReportData.forEach(pdto => {
      if (pdto.rowCheck) {
        let createDateTime: any;
        let invoiceNumberToBePrinted: any;
        createDateTime = this.datePipe.transform(pdto.poDate, this.appSettingService.globelDatePickerInUSAFormat);
        let bolCreateDateTime: any;
        if(pdto.invoiceNumber == "" || pdto.invoiceNumber == null || pdto.invoiceNumber == undefined){
          invoiceNumberToBePrinted="";
        }else{
          let invoiceNumberArray : any;
          invoiceNumberToBePrinted = pdto.invoiceNumber
          if(invoiceNumberToBePrinted.includes(",")){
            invoiceNumberArray = invoiceNumberToBePrinted.split(",");
            let invoiceNumberTemp ="";
            let number=0;
            for(var i =0; i< invoiceNumberArray.length; i++){
              if(invoiceNumberTemp==""){
                invoiceNumberTemp =invoiceNumberTemp+ invoiceNumberArray[i];
              }else{
                invoiceNumberTemp =invoiceNumberTemp+","+ invoiceNumberArray[i];
              }
                  number=i+1;
                if(number%2==0 ){
                  invoiceNumberTemp = invoiceNumberTemp+"\n";
                }

              }
              invoiceNumberToBePrinted="";
              invoiceNumberToBePrinted=invoiceNumberTemp;
          }
        }

        bolCreateDateTime = this.datePipe.transform(pdto.bolDate, this.appSettingService.globelDatePickerInUSAFormat);
        const temp = [createDateTime, pdto.poNumber , pdto.axaltaCartKey, pdto.supplierDocReferenceNumber, bolCreateDateTime,
invoiceNumberToBePrinted, pdto.distributorPayerNumber,pdto.partnerName, pdto.msoEntityName, pdto.msoPayerAccount, pdto.refCodeName, pdto.orderedQty, pdto.shippedQty];
        rows.push(temp);
      }
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 4.5,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        }
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }

  exportBOLReportTable(fileName) {
    const doc = new jsPDF('l', 'pt', 'a4');
 const col = ['PO Date', 'BOL Created Date', 'Account Payer Name', 'Distributor Payer Name', 'PO Status','PO Number', 'BOL Number', 'Total Shipped Quantity','ZCRA Status', 'ZDRA Status'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    this.fileExportService.selectedBOLReportData.forEach(bdto => {
      if (bdto.rowCheck) {
        let createDateTime: any;
        let invoiceNumberToBePrinted: any;
        // createDateTime = this.datePipe.transform(bdto.poDate, this.appSettingService.globelDatePickerInUSAFormat);
        let bolCreateDateTime: any;
     
        // bolCreateDateTime = this.datePipe.transform(pdto.bolDate, this.appSettingService.globelDatePickerInUSAFormat);
        const temp = [bdto.poDate , bdto.bolCreatedDate, bdto.accountPayerName, bdto.distributorPayerName,
        bdto.poStatus,bdto.poNumber,bdto.bolNumber, bdto.totalShippedQty, bdto.zcraStatus, bdto.zdraStatus];
        rows.push(temp);
      }
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 4.5,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        }
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }

  exportPOLineItemDetailReportTable(fileName) {
    const doc = new jsPDF('l', 'pt', 'a4');
 const col = ['PO Date', 'PO Number', 'Sold To Number', 'Sold To Name', 'Line Number','Material GMC', 'Axalta Code', 'Description', 
            'Material Ordered Quantity', 'Quantity Shipped'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    this.fileExportService.selectedPOLineItemDetailReportData.forEach(polineitemdto => {
      if (polineitemdto.rowCheck) {
        let createDateTime: any;
        let invoiceNumberToBePrinted: any;
        // createDateTime = this.datePipe.transform(bdto.poDate, this.appSettingService.globelDatePickerInUSAFormat);
        let bolCreateDateTime: any;
     
        // bolCreateDateTime = this.datePipe.transform(pdto.bolDate, this.appSettingService.globelDatePickerInUSAFormat);
        const temp = [polineitemdto.poDate , polineitemdto.poNumber, polineitemdto.soldToNumber, polineitemdto.soldToName,
          polineitemdto.lineNumber,polineitemdto.materialGMC, polineitemdto.axaltaCode,
          polineitemdto.discription, polineitemdto.materialQuantityOrdered, polineitemdto.qtshipped];
        rows.push(temp);
      }
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 4.5,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        }
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }


  exportCustomerMaterialTable(fileName) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['Create_Date','SAP_PAYER_NUM', 'EDI_TP_MATL_NUM', 'SAP_MATL_NUM', 'SAP_MIX_DESCR', 'EDI_TP_CONV_FACTOR','EDI_TP_UOM', 'SAP_QTY_CONV_FACTOR','SAP_QTY_UOM', 'EDI_TP_PRICE_CONV_FACTOR','EDI_TP_PRICE_UOM', 'SAP_PRICE_CONV_FACTOR','SAP_PRICE_UOM'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    this.fileExportService.selectedEdiMatlConvData.forEach(pdto => {
      if (pdto.rowCheck) {
        const temp = [this.datePipe.transform(pdto.createionDate, this.appSettingService.globelDatePickerInUSAFormat)  ,pdto.sapPayerNum, pdto.ediTpMatlNum, pdto.sapMatlNum, pdto.sapMixDescr, pdto.ediTpConvFactor,
          pdto.ediTpUom, pdto.sapQtyConvFactor, pdto.sapQtyUom, pdto.ediTpPriceConvFactor, pdto.ediTpPriceUom, pdto.sapPriceConvFactor, pdto.sapPriceUom];
        rows.push(temp);
      }
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 4,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        }
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }

  exportDunsIdTable(fileName) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['EDI TP ID', 'SAP Payer', 'Customer Name'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    this.fileExportService.selectedEdiDunsMasterData.forEach(pdto => {
      if (pdto.rowCheck) {
        const temp = [pdto.ediTpId, pdto.sapPayerNum ,  pdto.custName];
        rows.push(temp);
      }
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 7,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        }
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }

  exportPartnerStore(fileName) {
   const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['Jobber Cust ID', 'SAP Client Code', 'SAP Jobber Payer Num', 'SAP Cust Num', 'SAP Cust Ship Name'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    this.fileExportService.selectedStoreConvertData.forEach(pdto => {
      if (pdto.rowCheck) {
        const temp = [pdto.jobberCustId, pdto.sapClntCd ,  pdto.sapJobberPayerNum, pdto.sapCustNum ,  pdto.sapCustShipToName];
        rows.push(temp);
      }
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 7,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        }
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }

  exportMonthlyExceptionsReportsPdfAll(fileName, MonthlyExceptionsReportsList) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['Exceptions','Created Date ', 'MSO', 'Year', 'Month', 'Distributor Payer', 'Purchase Order Number','SupplierDocRefNumber',
     'Item Error Code', 'Item Error Description', 'Cart Key'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    MonthlyExceptionsReportsList.forEach(pdto => {
      let typeRec: any;
      let createdDate: any;
      let mso: any;
      let year: any;
      let month: any;
      let distributorPayer: any;
      let purchaseOrderNumber: any;
      let itemErrorCode: any;
      let itemErrorDescription: any;
      let supplierDocRefNumber: any;
      let axaltaCartKey: any;
      if (pdto.typeRec === null) {
        typeRec = '';
      } else {
        typeRec = pdto.typeRec;
      }
      if (pdto.createdDate === null) {
        createdDate = '';
      } else {
        createdDate = this.datePipe.transform(pdto.createdDate, this.appSettingService.globelDatePickerInUSAFormat);
      }
      if (pdto.mso === null) {
        mso = '';
      } else {
        mso = pdto.mso;
      }
      if (pdto.year === null) {
        year = '';
      } else {
        year = pdto.year;
      }
      if (pdto.month === null) {
        month = '';
      } else {
        month = pdto.month;
      }
      if (pdto.distributorPayer === null) {
        distributorPayer = '';
      } else {
        distributorPayer = pdto.distributorPayer;
      }
      if (pdto.purchaseOrderNumber === null) {
        purchaseOrderNumber = '';
      } else {
        purchaseOrderNumber = pdto.purchaseOrderNumber;
      }
      if (pdto.itemErrorCode === null) {
        itemErrorCode = '';
      } else {
        itemErrorCode = pdto.itemErrorCode;
      }
      if (pdto.itemErrorDescription === null) {
        itemErrorDescription = '';
      } else {
        itemErrorDescription = pdto.itemErrorDescription;
        var fixedSize=51;
        var minLength=0;
        if(itemErrorDescription.length > fixedSize){
          var totalLines = itemErrorDescription.length/fixedSize;
          for(var i=0; i<totalLines;i++){
            this.copyOfItemErrorDescription =this.copyOfItemErrorDescription+ itemErrorDescription.substring(minLength,fixedSize)+"\r";
            minLength=fixedSize;
            fixedSize=2*fixedSize;

          }
          itemErrorDescription=this.copyOfItemErrorDescription;
          this.copyOfItemErrorDescription="";
        }
      }
      if (pdto.supplierDocRefNumber === null) {
        supplierDocRefNumber = '';
      } else {
        supplierDocRefNumber = pdto.supplierDocRefNumber;
      }
      if (pdto.axaltaCartKey === null) {
        axaltaCartKey = '';
      } else {
        axaltaCartKey = pdto.axaltaCartKey;
      }
        const temp = [typeRec, createdDate, mso, year, month,distributorPayer,purchaseOrderNumber,supplierDocRefNumber,
          itemErrorCode, itemErrorDescription, axaltaCartKey];
        rows.push(temp);
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 5,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        },
        1: {columnWidth: 100},
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }




  exportMonthlyExceptionsReportsPdf(fileName) {
    const doc = new jsPDF('l', 'pt', 'a4');
    const col = ['Exceptions', 'Created Date ', 'MSO', 'Year', 'Month', 'Distributor Payer', 'Purchase Order Number','SupplierDocRefNumber',
    'Item Error Code', 'Item Error Description', 'Cart Key'];
    // tslint:disable-next-line:prefer-const
    let rows = [];
    this.fileExportService.selectedMonthlyExceptionsReportsData.forEach(pdto => {
      if (pdto.rowCheck) {
        let typeRec: any;
        let createdDate: any;
        let mso: any;
        let year: any;
        let month: any;
        let distributorPayer: any;
        let purchaseOrderNumber: any;
        let itemErrorCode: any;
        let itemErrorDescription: any;
        let supplierDocRefNumber: any;
        let axaltaCartKey: any;
        if (pdto.typeRec === null) {
          typeRec = '';
        } else {
          typeRec = pdto.typeRec;
        }
        if (pdto.createdDate === null) {
          createdDate = '';
        } else {
          createdDate = this.datePipe.transform(pdto.createdDate, this.appSettingService.globelDatePickerInUSAFormat);
        }
        if (pdto.mso === null) {
          mso = '';
        } else {
          mso = pdto.mso;
        }
        if (pdto.year === null) {
          year = '';
        } else {
          year = pdto.year;
        }
        if (pdto.month === null) {
          month = '';
        } else {
          month = pdto.month;
        }
        if (pdto.distributorPayer === null) {
          distributorPayer = '';
        } else {
          distributorPayer = pdto.distributorPayer;
        }
        if (pdto.purchaseOrderNumber === null) {
          purchaseOrderNumber = '';
        } else {
          purchaseOrderNumber = pdto.purchaseOrderNumber;
        }
        if (pdto.itemErrorCode === null) {
          itemErrorCode = '';
        } else {
          itemErrorCode = pdto.itemErrorCode;
        }
        if (pdto.itemErrorDescription === null) {
          itemErrorDescription = '';
        } else {
          itemErrorDescription = pdto.itemErrorDescription;
          var fixedSize=51;
          var minLength=0;
          if(itemErrorDescription.length > fixedSize){
            var totalLines = itemErrorDescription.length/fixedSize;
            for(var i=0; i<totalLines;i++){
              this.copyOfItemErrorDescription =this.copyOfItemErrorDescription+ itemErrorDescription.substring(minLength,fixedSize)+"\r";
              minLength=fixedSize;
              fixedSize=2*fixedSize;

            }
            itemErrorDescription=this.copyOfItemErrorDescription;
            this.copyOfItemErrorDescription="";
          }
        }
        if (pdto.supplierDocRefNumber === null) {
          supplierDocRefNumber = '';
        } else {
          supplierDocRefNumber = pdto.supplierDocRefNumber;
        }
        if (pdto.axaltaCartKey === null) {
          axaltaCartKey = '';
        } else {
          axaltaCartKey = pdto.axaltaCartKey;
        }

        const temp = [typeRec, createdDate, mso, year, month,distributorPayer,purchaseOrderNumber,supplierDocRefNumber,
          itemErrorCode, itemErrorDescription, axaltaCartKey];
        rows.push(temp);
      }
    });
    // doc.autoTable(col, rows);
    doc.autoTable(col, rows, {
      startY: 40,
      margin: {
        top: 40
      },

      styles: {
        fontSize: 5,
        overflow: 'linebreak',
        columnWidth: 'wrap',
      },
      headStyles: {
        valign: 'middle',
        halign: 'left'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        },
        1: {columnWidth: 100},
      },
      theme: 'grid'
    });

    doc.save(fileName + '.pdf');
  }
}
